import { InputAdornment, TextField } from "@mui/material";
import { useRef, useState } from "react";
const MoneyFormatv2 = (number, currency) => {

    if (number === "-") {
        return number;
    }
    if (number === ".") {
        return "0.";
    }
    if (number === "" || !number) {
        return "";
    }
    function hasTwoDecimalPlacesAndEndsWithZero(number) {
        let numberInt = parseInt(number * 100);
        const decimalPart = (numberInt % 100).toFixed(2); // Get the two decimal places

        if (decimalPart == 0) {
            return false;
        }

        if (
            numberInt?.toString().length - number?.toString().length != -1 ||
            number[0] == "0"
        ) {
            return false;
        } else {
            return true;
        }
    }
    if (!currency) {
        currency = "en-IN";
    }
    if (typeof number === "string") {
        if (number[number.length - 1] === ".")
            return (
                new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(
                    number
                ) + "."
            );
        else if (
            number[number.length - 1] === "0" &&
            number[number.length - 2] === "."
        )
            return (
                new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(
                    number
                ) + ".0"
            );
    }
    // console.log(number);
    if (isNaN(number)) {
        return "";
    } else {
        if (hasTwoDecimalPlacesAndEndsWithZero(number)) {
            return new Intl.NumberFormat(currency, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
            }).format(number);
        } else {
            return new Intl.NumberFormat(currency, {
                maximumFractionDigits: 2,
            }).format(number);
        }
    }
};
const MoneyFormatv3 = (number, currency) => {
    if (number === "" || !number) {
        return "0.00";
    }
    return new Intl.NumberFormat("en-IN", {
        // style: 'currency',
        // currency: currency,
        minimumFractionDigits: 2, // Minimum decimal places
        maximumFractionDigits: 2, // Maximum decimal places
    }).format(number);
};

export const MoneyInputv3 = ({
    name,
    placeholder,
    size,
    type,
    value,
    onChange = () => { },
    onBlur = () => { },
    onFocus = () => { },
    onKeyDown = () => { },
    onClick = () => { },
    state,
    disabled,
    required,
    endAdornment,
    style,
    inputRef,
    label,
    id,
    variant,
    sx,
    inputProps,
    currencyType = "₹",
    error
}) => {
    const [active, setactive] = useState(false);
    const inputElement = useRef({});

    const handleFocus = (e) => {
        setactive(true);
        onFocus && onFocus(e);
        e.stopPropagation();
    }
    const handleClick = (e) => {
        onClick && onClick(e)
        e.stopPropagation()
    }
    const handleBlur = (e) => {

        setactive(false);
        let value = new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        }).format(state);
        onBlur && onBlur(value);
        if (value === "0.00") {
            // onChange("");
        } else {
            // onChange(value);
            // onBlur(value);
        }

    }

    const handleChange = (e) => {
        let value = e.target.value;
        value = value.replace(/,/g, "");
        const cursorPosition = e.target.selectionStart;
        if (!/^\d*(?:\.\d*)?$/.test(value)) {
            return;
        }
        if (/^\d*\.?\d{0,2}$/.test(value) === false) {
            return;
        }
        onChange(value);
    }

    return (
        <TextField
            error={error ? error : ""}
            key={id}
            id={id}
            variant={variant}
            disabled={disabled}
            onClick={handleClick}
            onFocus={handleFocus}
            label={label}
            inputRef={inputRef}
            onKeyDown={onKeyDown}
            onBlur={handleBlur}
            value={active ? MoneyFormatv2(state) : MoneyFormatv3(state)}
            onChange={handleChange}
            slotProps={{
                input: {
                    readOnly: true,
                },
            }}
            fullWidth
            size="small"
            sx={{
                textAlign: "right",
                ".MuiInputBase-root": {
                    fontSize: "14px",
                },
                label: {
                    fontSize: "14px",
                },
                ".MuiFormLabel-root": {
                    color: "input.font",
                },
                ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "input.border",
                },
                ".MuiOutlinedInput-input": {
                    textAlign: "right",
                },
                ...sx,
            }}
            InputProps={{
                inputRef: inputElement,
                startAdornment: <InputAdornment position="start">{currencyType}</InputAdornment>,
                inputProps: {
                    style: {
                        textAlign: "right",
                    },
                    min: 0,
                    readOnly: inputProps?.readOnly,
                },
            }}
        />
    );
};
